import { useListGlobalTopicsPageModel } from './list-global-topics-page.model'
import type { IListGlobalTopicsPageProps } from './list-global-topics-page.types'
import { ListGlobalTopicsPageView } from './list-global-topics-page.view'

export const ListGlobalTopicsPage = ({ isGlobalTaxonomyEnabled }: IListGlobalTopicsPageProps) => {
  const listGlobalTopicsPageModel = useListGlobalTopicsPageModel()
  return <ListGlobalTopicsPageView {...listGlobalTopicsPageModel} isGlobalTaxonomyEnabled={isGlobalTaxonomyEnabled} />
}
